export default {"src":"/_next/static/media/Gastric-Cancer.5cf216a5.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};